var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14554 13.3776C7.30084 13.3776 6.61667 12.6935 6.61667 11.8488C6.61667 11.0041 7.30084 10.3199 8.14554 10.3199C8.99024 10.3199 9.67441 11.0041 9.67441 11.8488C9.67441 12.6935 8.99024 13.3776 8.14554 13.3776ZM15.6446 6.75762L8.94052 0.321063C8.49715 -0.107021 7.79387 -0.107021 7.35049 0.321063L0.646385 6.75762C-0.0989403 7.47237 0.405588 8.72987 1.4414 8.72987H2.03002V16.4354C2.03002 17.4903 2.88618 18.3465 3.94111 18.3465H12.3499C13.4048 18.3465 14.261 17.4903 14.261 16.4354V8.72987H14.8496C15.8854 8.72987 16.39 7.47237 15.6446 6.75762Z",
    fill: "#AFC0D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHome);
export default __webpack_public_path__ + "static/media/landingHome.c9f1ba1a6b603dc908b1d4dade6b8386.svg";
export { ForwardRef as ReactComponent };